<template>
  <div class="empty">
    <img src="../image/empty.png" alt="">
    <p>{{text}}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>
<style scoped>
.empty{
  width: 100%;
  padding: 20px 0;
}
img{
  display: block;
  margin: 0 auto;
  width: 120px;
}
p{
  margin-top: 10px;
  text-align: center;
}
</style>